import React from "react";
import { Flex, Text, Tooltip } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import useGetMyDashboardLinkedUrlSiteInfo from "@/features/my-dashboard/hooks/useGetMyDashboardLinkedUrlSiteInfo";
import useIdentity from "@/features/ui/hooks/use-identity";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

function MyDashboardLinkedSite() {
  const identity = useIdentity();
  const { linkedUrlSiteInfo } = useGetMyDashboardLinkedUrlSiteInfo(
    identity?.company?.id
  );
  const { tSentence } = useI18nHelper();

  return (
    <Flex flexDirection={"column"} gap={"6px"}>
      <Tooltip
        label={
          <Text textStyle={"body-sm-medium"}>
            {linkedUrlSiteInfo?.shopping_mall_url}
          </Text>
        }
        hasArrow={true}
        placement={"bottom"}
        openDelay={500}
      >
        <Flex
          padding={"8px 12px"}
          borderRadius={"4px"}
          boxShadow={"0 0 0 0.5px #8F8F8C"}
          gap={"6px"}
          background={"#FFFFFF"}
        >
          <SVG
            src={"/icons-v1_1/link.svg"}
            width={24}
            height={24}
            color={"#8F8F8C"}
          />
          <Text textStyle={"body-md-regular"} color={"#6F6F6C"} noOfLines={1}>
            {linkedUrlSiteInfo?.status === "COMPLETED"
              ? linkedUrlSiteInfo.shopping_mall_url
              : "https://pathrade.com/"}
          </Text>
        </Flex>
      </Tooltip>
      <Flex gap={"4px"}>
        <SVG
          src={"/icons-v1_1/info-circle.svg"}
          width={16}
          height={16}
          color={"#8F8F8C"}
        />
        <Text textStyle={"caption-regular"} color={"#6F6F6C"}>
          {tSentence("my_dash:link_info")}
        </Text>
      </Flex>
    </Flex>
  );
}

export default MyDashboardLinkedSite;
